export default {
  cards: null
};